import moment from 'moment'
import {Base, model, belongsTo, endpoint, property} from '@scoutgg/ftw/source/lib/model'
import config from '@scoutgg/ftw/source/services/config'
import serialize from '@scoutgg/ftw/source/decorators/serialize';

function maybeMoment(value) {
  return value == null ? value : moment(value)
}

@model('MatchSource')
@endpoint('match-sources', {root: '/api'})
@belongsTo('match')
@belongsTo('matchSource')
@belongsTo('seasonSource')
@belongsTo('teamSources', 'TeamSource')
@belongsTo('teamOverrides', 'Team')
@serialize([ 'startTime', 'endTime' ])
export class MatchSource extends Base {
  @property(maybeMoment) startTime;
  @property(maybeMoment) endTime;

  get home() {
    var team = this.homeSource && this.homeSource.team
    return team && team.name
  }
  
  get away() {
    var team = this.awaySource && this.awaySource.team
    return team && team.name
  }
  get homeSource() {
    return this.teamSources && this.teamSources[0]
  }
  get awaySource() {
    return this.teamSources && this.teamSources[1]
  }
  get homeTeamId() {
    return this.homeSource.teamId
  }
  get awayTeamId() {
    return this.awaySource.teamId
  }
  addOverride(team) {
    if(!team) return
    if(!this.teamOverridesId) this.teamOverridesId = []
    var id = config.getId(team) || team
    if(~this.teamOverridesId.indexOf(id)) return
    this.teamOverridesId.push(id)
  }

  removeOverride(team) {
    var id = config.getId(team) || team
    var index = this.teamOverridesId.indexOf(id)
    if(!~index) return
    this.teamOverridesId.splice(index, 1)
  }
}
